import { render, staticRenderFns } from "./MediaWrap.vue?vue&type=template&id=0bafadeb&"
import script from "./MediaWrap.vue?vue&type=script&lang=js&"
export * from "./MediaWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports